

exports.__esModule = true;
var $env = exports.$env = {

    isLocal: function isLocal() {
        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
    },

    isStage: function isStage() {
        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
    },

    isSandbox: function isSandbox() {
        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
    },

    isLive: function isLive() {
        return window.location.hostname === 'www.paypal.com';
    },

    isTest: function isTest() {
        return false;
    }
};

angular.value("$env", $env);


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/paypal/env.js
 ** module id = 145
 ** module chunks = 1
 **/